class Placement {
    id = null;
    application_id = null;
    vacancy_id = null;
    seafarer_id = null;
    maritime_object_id = null;
    rank_id = null;
    seniority = null;
    placement_status_id = 2;
    status_notes = '';
    boc_date = null;
    sign_on_date = null;
    sign_off_date = null;
    eoc_date = null;
    flight_reservation = '';
    travel_info = '';
    po_number = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Placement;
